import { IconWrapper } from '../runtime';
export default IconWrapper('author', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.7098 7.89158L15 7.49976M10 14.2498L13.2251 9.89582",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.5 8.74957H5.75C4.09315 8.74957 2.75 10.0927 2.75 11.7496V13.9496C2.75 14.1153 2.88431 14.2496 3.05 14.2496H7.5M10.75 3.74976C10.75 5.26854 9.51878 6.49976 8 6.49976C6.48122 6.49976 5.25 5.26854 5.25 3.74976C5.25 2.23097 6.48122 0.999756 8 0.999756C9.51878 0.999756 10.75 2.23097 10.75 3.74976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});